import { Vector2 } from './vector';

export interface Body {
  id: number;
  pos: Vector2;
  vel: Vector2;
  mass: number;
  radius: number;
  color: string;
  trail: Vector2[];
  fixed: boolean;
}

let nextId = 1;

export function createBody(
  pos: Vector2,
  vel: Vector2,
  mass: number,
  color: string,
  fixed = false
): Body {
  const radius = Math.max(2, Math.pow(mass, 1 / 3) * 2);
  return {
    id: nextId++,
    pos: pos.clone(),
    vel: vel.clone(),
    mass,
    radius,
    color,
    trail: [],
    fixed,
  };
}

export function resetIdCounter(): void {
  nextId = 1;
}
